import { lazyInitializeCalendarsDataForModule } from 'owa-calendar-bootstrap-utils';
import { lazyLoadWorkloadScenarioSettings } from 'owa-workload-scenario-settings';

export function prefetchTimePanelResources(): void {
    lazyInitializeCalendarsDataForModule.import();
    lazyLoadWorkloadScenarioSettings.import();
}
